export function normalizeAddress(address: string, prefix = '0x') {
    return address.startsWith(prefix) ? address : `${prefix}${address}`;
}

export function truncateContractAddress(value = '') {
    const prefixLength = 6;
    const suffixLength = 4;

    const segments = [value.slice(0, prefixLength), '…', value.slice(suffixLength * -1)];

    return value.length > prefixLength + suffixLength ? segments.join('') : value;
}
